module.exports = "<chassis-auth-page-wrapper-component>\n    <p class=\"p-t-35\">{{ \"Enter the password reset code we\\'ve sent to the given email address.\" | translate }}</p>\n\n    <chassis-auth-password-reset-component></chassis-auth-password-reset-component>\n</chassis-auth-page-wrapper-component>"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/authentication/pages/password-reset/password-reset.page.html
// module id = ./libs/chassis-core/src/app/authentication/pages/password-reset/password-reset.page.html
// module chunks = main